var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"edit-product"}},[(_vm.plan)?_c('div',{staticClass:"p-4"},[_c('plan-details',{attrs:{"plan":_vm.plan},on:{"planUpdated":_vm.fetchPlan}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }